import { cssClass } from '@/shared/utils'
import { columnLeft, columnRight } from '../styles/twoColumnsLayout.css'

interface ProfileTwoColumnsLayoutProps {
  leftColumnEl?: React.ReactNode
  rightColumnEl?: React.ReactNode
  leftColumnClassName?: string
  rightColumnClassName?: string
  useReverseMobileLayout?: boolean
  useReverseDesktopLayout?: boolean
}

export const ProfileTwoColumnsLayout = ({
  leftColumnEl,
  rightColumnEl,
  leftColumnClassName,
  rightColumnClassName,
  useReverseMobileLayout,
  useReverseDesktopLayout,
}: ProfileTwoColumnsLayoutProps) => {
  return (
    <>
      <div id="productFruits" className="z-20"></div>
      <div
        className={cssClass([
          'flex',
          'gap-16 gap-48--desktop full-w',
          'mt-28--desktop',
          useReverseMobileLayout
            ? 'flex-column-reverse mt-10--tablet'
            : 'flex-column mt-40--tablet',
          useReverseDesktopLayout
            ? 'flex-row-reverse--desktopXl'
            : 'flex-row--desktopXl',
        ])}
      >
        <div className={cssClass([columnLeft, leftColumnClassName])}>
          {leftColumnEl}
        </div>
        <div
          className={cssClass([
            columnRight,
            rightColumnClassName,
            useReverseMobileLayout && 'mt-16 mt-0--desktopXl',
          ])}
        >
          {rightColumnEl}
        </div>
      </div>
    </>
  )
}
